import React from 'react';

import Checkbox from '/component/base/Checkbox';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import {withTranslation} from '/provider/TranslationProvider';

interface QualifyingPointsContentProps {
  tt: (key: string, fallback: string) => string;
  data: {
    current: number;
  };
  isComplete: boolean;
}

const QualifyingPointsContent: React.FC<QualifyingPointsContentProps> = ({
  tt,
  data = {current: 0},
  isComplete = false,
}) => {
  return (
    <ListItem
      prefix={<Checkbox checked={isComplete} />}
      label={
        <Text>
          {data.current}{' '}
          {data.current > 1 || data.current === 0
            ? tt('label', 'Qualifying Points')
            : tt('label', 'Qualifying Point')}
        </Text>
      }
      readonly
    />
  );
};

export default withTranslation(
  'report.closeToCompetencyContent.qualifyingPoints',
)(QualifyingPointsContent);
